
export class ServiceCopyProperties {
  public newServiceName: string;
  public serviceSelected: boolean = true;
  public costsSelected: boolean = false;
  public requirementsSelected: boolean = false;
  public resultsSelected: boolean = false;
  public activityConditionsSelected: boolean = false;
  public registrationLawsSelected: boolean = false;
  public serviceLocationsSelected: boolean = false;
  public serviceTutorialsSelected: boolean = false;
  public serviceTranslationsSelected: boolean = false;
  public guideFormSelected: boolean = false;
  public applicantFormSelected: boolean = false;
  public sendFileFormSelected: boolean = false;
  public paymentFormSelected: boolean = false;
  public catalogsSelected: boolean = false;
  public rolesSelected: boolean = false;
  public registrationsSelected: boolean = false;
  public determinantsSelected: boolean = false;
  public printDocumentsSelected: boolean = false;
  public copyService: boolean = false; // if copy service in the same instance
  public catalogsToCopy: any[]; // the names of the catalogs to be copied
  public botsSelected: boolean = false;
}
